import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: "30px 0px",
  },
  title: {
    fontSize: "23px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "20px",
  },
  underline: {
    paddingBottom: "4px",
    borderBottom: "1px solid #000",
  },
  card: {
    margin:'2px'
  },
  img: {
    width: "100%",
    maxWidth: "400px",
    height: "auto",
  },
}));

export default function VideoLink() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <p className={classes.title}>
        <span className={classes.underline}>Vide</span>os
      </p>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <div className={classes.card}>
            <img
              src="https://i.ytimg.com/vi/dHrc0PnJv78/mqdefault.jpg"
              className={classes.img}
            />
            <Typography variant="body1">
              iPhone 12 Pro Max vs Galaxy Note 20 Ultra! | VERSUS
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={3}>
          <div className={classes.card}>
            <img
              src="https://i.ytimg.com/vi/dHrc0PnJv78/mqdefault.jpg"
              className={classes.img}
            />
            <Typography variant="body1">
              iPhone 12 Pro Max vs Galaxy Note 20 Ultra! | VERSUS
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={3}>
          <div className={classes.card}>
            <img
              src="https://i.ytimg.com/vi/dHrc0PnJv78/mqdefault.jpg"
              className={classes.img}
            />
            <Typography variant="body1">
              iPhone 12 Pro Max vs Galaxy Note 20 Ultra! | VERSUS
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={3}>
          <div className={classes.card}>
            <img
              src="https://i.ytimg.com/vi/dHrc0PnJv78/mqdefault.jpg"
              className={classes.img}
            />
            <Typography variant="body1">
              iPhone 12 Pro Max vs Galaxy Note 20 Ultra! | VERSUS
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
